import estilos from "./CampoColorHex.module.css";

export const HEX_RE = /^#[0-9a-fA-F]{6}$/;

interface Props {
  id: string;
  etiqueta: string;
  valor: string;
  onChange: (valor: string) => void;
  deshabilitado?: boolean;
}

// Swatch + input hex reutilizable (patron de PaletaColores.tsx del hermano
// "AI Video editor"): un unico campo, para poder usarse tanto en la paleta de
// marca (4 campos) como en el color de una capa de texto/forma individual.
export function CampoColorHex({
  id,
  etiqueta,
  valor,
  onChange,
  deshabilitado,
}: Props): JSX.Element {
  const valido = HEX_RE.test(valor);
  return (
    <div className={estilos.campo}>
      <div
        className={estilos.muestra}
        style={{ background: valido ? valor : "#000" }}
        aria-hidden="true"
      />
      <label htmlFor={id}>{etiqueta}</label>
      <div className={estilos.entrada}>
        <input
          id={id}
          type="color"
          value={valido ? valor : "#000000"}
          onChange={(e) => onChange(e.target.value)}
          disabled={deshabilitado}
          aria-label={`Selector de color ${etiqueta}`}
        />
        <input
          type="text"
          className={estilos.hex}
          value={valor}
          onChange={(e) => onChange(e.target.value)}
          disabled={deshabilitado}
          aria-label={`Hex ${etiqueta}`}
          aria-invalid={!valido}
          maxLength={7}
          spellCheck={false}
        />
      </div>
      {!valido && (
        <span className={estilos.errorHex} role="alert">
          Debe ser un hex valido (#RRGGBB)
        </span>
      )}
    </div>
  );
}
